import { ParagraphDto } from '../paragraph/paragraph.model';
import { Exercise } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapParagraphToExercises(
  paragraphDto: ParagraphDto,
): Exercise[] {
  return paragraphDto.exercises.map((exercise) => {
    return {
      id: exercise.id,
      questionnaireId: exercise.questionnaireId,
      exerciseType: exercise.exerciseType,
    };
  });
}
